import * as React from 'react'
import ReactHtmlParser from 'react-html-parser'
import Link from 'src/shared/Link/Link'
import { config } from 'src/conf/config'
import { IPublicProduct, PublicProductStatusMap, PublicProductProfileMap } from 'src/type/public-product'

interface IProps {
    entity: IPublicProduct
}

const NewsContent = (message: any) => (ReactHtmlParser(message))

const PublicProductCard = (props: IProps) => {
    const {entity} = props;
    return (
        <div className="public-card">
            <Link to={`${config.baseUrl}/public-product/${entity.id}`}>
                <header 
                    className="public-card__header" 
                    style={{backgroundImage: `url(${entity.image_cover_url ? entity.image_cover_url : config.IMG_BASE_PATH + "/site/photo/products.jpg"})`}}
                >
                    <div className="public-card__tag-infos">
                        <p className="public-card__categories">{PublicProductStatusMap[entity.status]}</p>
                        <p className="public-card__categories">{PublicProductProfileMap[entity.profile]}</p>
                    </div>
                </header>
                <section className="public-card__body">
                    <p className="public-card__title">{entity.name}</p>
                    <div className="public-card__content">
                        {NewsContent(entity.description)}
                    </div>
                </section>   
            </Link>
            {entity.documents && entity.documents.length > 0 &&
                <div className="text-center mg-t-1r mg-b-1r" >
                    <a className="btn-outline" href={entity.documents[0].permalink}>
                        Télécharger la brochure
                    </a>
                </div>
            }
        </div>
    )
}

export default PublicProductCard


// WEBPACK FOOTER //
// ./src/page/PublicProduct/PublicProductCard.tsx